import { render, staticRenderFns } from "./PlanBlock.vue?vue&type=template&id=dbac0402&scoped=true"
import script from "./PlanBlock.vue?vue&type=script&lang=js"
export * from "./PlanBlock.vue?vue&type=script&lang=js"
import style0 from "./PlanBlock.vue?vue&type=style&index=0&id=dbac0402&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbac0402",
  null
  
)

export default component.exports